import React from "react";
import {Badge} from '@shopify/polaris';
import {useHistory, useLocation} from 'react-router-dom'

function NavLink({label, to, id, match}) {
    const router = useHistory();
    const activeClass = match ? "Polaris-Tabs__Tab--selected" : "";
    return (
        <li key={id} className="Polaris-Tabs__TabContainer" role="presentation">
            <div onClick={() => {
                router.push(to);
            }} className={`Polaris-Tabs__Tab ${activeClass}`}>
                <span className="Polaris-Tabs__Title">
                    {label}{' '}{label === 'Automation' && <Badge status='success'>New</Badge>}
                </span>
            </div>
        </li>
    );
}

const Nav = ({links}) => {
    const location = useLocation();
    if (links.length > 0) {
        const currentUrl = location.pathname;
        return (
            <div className="Polaris-Tabs__Wrapper custom">
                <ul className="Polaris-Tabs" role="tablist">{links.map((tab) => {
                    const tabUrl = tab.url;
                    const active = (currentUrl === tab.url || (currentUrl.substring(0, tabUrl.length) === tabUrl && tabUrl !== "/"));
                    return (
                        <NavLink id={tab.id} key={tab.id} label={tab.accessibilityLabel} activeOnlyWhenExact={true}
                                 to={tab.url}
                                 match={active}/>
                    )
                })}
                </ul>
            </div>
        );
    }
    return (<></>);
}

export default Nav;
